import { ITranslationKeys } from '../ITranslationKeys'

export const en: ITranslationKeys = {
    alert: {
        heading: 'Uh-oh! It seems there’s an issue.',
        generic:
            'Please refresh, or contact support if the problem continues. Thanks for your patience!',
        expiredSession: (count: number = 0) =>
            `It appears your session has expired. Redirecting in ${count} seconds...`,
        retry: 'Retry',
        noData: {
            heading: 'No data available',
        },
    },
    banner: {
        opensNewTab: 'Opens in a New Tab',
    },
    common: {
        goBackAriaLabel: 'Go Back to the Previous Screen',
        cancel: 'Cancel',
        continue: 'Continue',
    },
    dateFormat: {
        monthAbbreviations: {
            Jan: 'Jan',
            Feb: 'Feb',
            Mar: 'Mar',
            Apr: 'Apr',
            May: 'May',
            Jun: 'Jun',
            Jul: 'Jul',
            Aug: 'Aug',
            Sep: 'Sep',
            Oct: 'Oct',
            Nov: 'Nov',
            Dec: 'Dec',
        },
        weekFormat: '{{month}} Week {{weekNumber}}',
        dayFormat: '{{month}} {{day}}',
    },
    assetsProtection: {
        title: 'Assets Protection',
        filters: {
            viewInDollars: 'View in $',
            viewInPercent: 'View in %',
        },
        yearToDate: 'YTD',
        tabs: {
            payroll: 'Payroll',
            theft: 'Theft',
            secure: 'Secure',
        },
        secure: {
            title: 'Secure',
            security: 'Security',
            location: 'Location',
            crimesAgainstProperty: 'Crimes Against Property',
            crimesAgainstPeople: 'Crimes Against People',
            disorderlyConducts: 'Disorderly Conducts',
            securityResolution: 'Security Resolution %',
            'disorderly conducts': 'Disorderly Conducts',
            'crimes against people': 'Crimes Against People',
            'crimes against property': 'Crimes Against Property',
            ty: 'TY',
            'b/(p) to ly': 'B/(P) to LY',
        },
        payroll: {
            actual: 'Actual',
            plan: 'Plan',
            published: 'Published',
            'b/(p) to plan': 'B/(P) to Plan',
            'b/(p) to published': 'B/(P) to Published',
            payrollBPLYLabel: 'B/P to Plan',
            apl: 'APL',
            aps: 'APS',
            tps: 'TPS',
        },
        theft: {
            'merchandise investigations': 'Merchandise Investigations',
            'POS/other investigations': 'POS/Other Investigations',
            'detained apprehensions': 'Detained Apprehensions',
            'external app productivity': 'External App Productivity',
            'average app $': 'Average App $',
            'NPI rate': 'NPI Rate',
            PMR: 'PMR',
            KTR: 'KTR',
            ty: 'TY',
            'b/(p) to ly': 'B/(P) to LY',
            'days to close (avg)': 'Days to Close (Avg)',
            internal: 'Internal',
            external: 'External',
        },
        internal: 'Internal',
        external: 'External',
        priorWeek: 'Prior Week',
        priorMonth: 'Prior Month',
        headers: {
            internal: {
                loc: 'Location',
                merchCases: 'Merch Cases',
                merchCasesBPLY: 'Merch Cases B/(P) to LY',
                posOtherCases: 'POS/Other Cases',
                posOtherCasesBPLY: 'POS/Other Cases B/(P) to LY',
                daysToClose: 'Days to Close (Avg)',
            },
            external: {
                loc: 'Location',
                detainedApps: 'Detained Apps',
                KTRToAppPercent: 'KTR to App %',
                externalAppProductivity: 'External App Productivity',
                averageAppDollars: 'Average App $',
                npiRate: 'NPI Rate',
            },
            payrollRGDMonthly: {
                Store: 'Location',
                Region: 'Location',
                Group: 'Location',
                District: 'Location',
                'Actual Hrs': 'Actual',
                'Plan Hrs': 'Plan Hours',
                'Published Hrs': 'Published',
                'b/(p) to Plan': 'B/(P) to Plan',
                'b/(p) % to Plan': 'B/(P) to Plan',
                'b/(p) % to Published': 'Published',
            },
        },
    },
    indexRedirectMessage: 'Redirecting to login',
    layout: {
        appTitle: 'myPerformance Mobile',
        greenfieldLinkTitle: 'Greenfield',
        logOutCTA: 'Log Out',
        navMenuAriaLabel: 'Open navigation menu',
        navMenuCloseAriaLabel: 'Close navigation menu',
        searchAriaLabel: 'Search for a location',
    },
    locationSearch: {
        header: 'Select Location',
        searchLabel: 'Search Region, Group, District, or Store',
        matchNotFound:
            'no location matched your search. showing nearby locations.',
        nearbyLocationsHeader: 'Nearby Locations',
        clearSearchAriaLabel: 'Clear Location Search Query',
    },
    brands: {
        title: 'Brands',
        search: 'Search by Brand Name',
        clearSearch: 'Clear Location Search Query',
        goBackAriaLabel: 'Go Back to the Brands Screen',
        noData: 'No Data Available',
        trend: 'Trend',
        headings: {
            location: 'Location',
            sales: 'Sales',
            orgSales: 'Orig. Sales',
            fulSales: 'Ful. Sales',
            originated: 'Originated',
            shipFromStore: 'Ship From Store',
            orderPickup: 'Order Pickup',
            compPercent: 'Comp %',
            itemDescription: 'Item Description',
            quantity: 'Qty',
            subclass: 'Subclass',
            loyaltyOrigTrans: 'Loyalty Orig. Trans %',
        },
        tabs: {
            top: 'Top',
            bottom: 'Bottom',
        },
    },
    storeFulfillment: {
        title: 'Store Fulfillment',
        tabs: {
            pickup: 'Pickup',
            ship: 'Ship',
            inf: 'INF',
            ndd: 'NDD',
            capabilities: 'Capabilities',
        },
        timePeriods: {
            today: 'Today',
            yesterday: 'Yesterday',
            weekToDate: 'Week to Date',
            lastWeek: 'Last Week',
            monthToDate: 'Month to Date',
            yearToDate: 'Year to Date',
        },
        headings: {
            location: 'Location',
            pickup: 'Pickup',
            groceryPickup: 'Grocery Pickup',
            driveUp: 'Drive Up',
            driveUpReturns: 'Drive Up Returns',
            driveUpStarbucks: 'Drive Up Starbucks',
            parkingLotDeliveryPause: 'Parking Lot Delivery Pause',
            sfs: 'SFS',
            ndd: 'NDD',
            sdd: 'SDD',
            infPercent: 'INF %',
            infDollars: 'INF $',
            pickedOnTime: 'Picked On Time %',
            driveUpWaitTime: 'Drive Up Wait Time %',
            receivedUnits: 'Received Units',
            openLateUnits: 'Open Late Units',
            openUnits: 'Open Units',
            pickedUnitsToday: 'Picked Units Today',
            pickedUnits: 'Picked Units',
            forecastedToday: 'Forecasted Today',
            totalPickupInf: 'Total Pickup INF %',
            totalPickupAttempted: 'Total Pickup Units Attempted',
            pickupUnitsAttempted: 'Pickup Units Attempted',
            groceryUnitsAttempted: 'Grocery Units Attempted',
            totalPickupPickProductivity: 'Total Pickup Pick Productivity (UPH)',
            compPercent: 'Comp %',
            forecastedUnits: 'Forecasted Units',
            openUnitsCarrier: 'Open Units by Carrier Pickup',
            openUnitsPack: 'Open Units to Pack Today',
            shipByTime: 'Ship By Time',
            sortByTime: 'Sort By Time',
            pick: 'Pick',
            pack: 'Pack',
            total: 'Total',
            teamMember: 'Team Member',
            attemptedUnits: 'Attempted Units',
            picksPerHour: 'Picks per Hour',
            unitsPacked: 'Units Packed',
            packsPerHour: 'Packs per Hour',
            unitPlan: 'Unit Plan',
            shipOnTimePercent: 'Ship on Time %',
            pickProductivity: 'Pick Productivity',
            packProductivity: 'Pack Productivity',

            todaysWork: "Today's Work",
            carryoverUnits: 'Prior Day Carryover Units',
            completedUnits: 'Completed Units',
            remainingUnitPlan: 'Remaining Unit Plan',
            percentINF: '% INF (At Goal)',
            priorDayLateUnits: 'Prior Day Late Units',
            priorDayCarryoverUnits: 'Prior Day Carryover Units',
            containersToSort: 'Containers to Be Sorted',
            sortedOnTime: 'Sorted on Time',
            handoffAccuracy: 'Handoff Accuracy',
            lateUnits: 'Late Units',
            carryOverUnits: 'Carryover Units',
        },
        titles: {
            unitVolume: 'Unit Volume',
            teamMemberProductivity: 'Team Member Productivity',
            todayAsOf: 'Today as of',
            carrierPickup: 'Carrier Pickup',
            totalUnitsToPack: 'Total Units to Pack Today',
            remainingAvailable: 'Remaining Available',
        },
        shipOnTimeHeadings: {
            location: 'Location',
            originalPackagesDue: 'Original Packages Due',
            acceptedCarrierIssuePackages: 'Accepted Carrier Issue Packages',
            totalPackagesDue: 'Total Packages Due',
            shipOnTimePercent: 'Ship on Time %',
            packagesNotSortedOnTimePercent: 'Packages Not Sorted on Time %',
            packagesNotShippedNoCarrierIssuePercent:
                'Packages Not Shipped & No Carrier Issue Submitted %',
            mnrPackagesPercent: 'MNR Packages %',
        },
        shipOnTimeNote:
            'Ship on Time may change over the next four days as MNRs are picked up.',
        toggles: {
            showStores: 'Show Stores',
            showDistricts: 'Show Districts',
        },
        ndd: {
            routeSort: 'Route Sort',
            handoff: 'Handoff',
            byTime: 'By Time',
            completed: 'Completed',
            totalExpected: 'Total Expected',
            percentOnTime: '% On Time',
            accuracy: 'Accuracy',
            asOf: 'As of',
            containersSorted: 'Containers Sorted',
            infPercent: 'INF %',
            sortedOnTime: 'Sorted on Time',
            shippedOnTime: 'Shipped on Time',
        },
        inf: {
            store: {
                orderPickupOPU: 'Pickup (OPU)',
                units: 'Units',
                dollars: 'Dollars',
                inf: 'INF %',
                sfs: 'SFS %',
                shipFromStoreSFS: 'Ship From Store (SFS)',
                infTime: 'INF Time',
                infUnits: 'INF Units',
                attemptedUnits: 'Attempted Units',
                dpci: 'DPCI',
                item: 'Item',
                teamMember: 'Team Member',
                totalMinutes: 'Total Minutes',
                orderNumber: 'Order Number',
                asOf: 'As of',
                capabilityStatus: 'Capability Status',
                ON: 'ON',
                OFF: 'OFF',
                PAUSED: 'PAUSED',
                lastUpdated: 'Last Updated',
                reason: 'Reason',
                department: 'Department',
            },
            rgdHeadings: {
                pickup: {
                    totalPickupInf: 'Total Pickup INF',
                    pickupINFApparel: 'Pickup INF, Apparel/Accessories',
                    pickupINFBeauty: 'Pickup INF, Essentials/Beauty',
                    pickupINFFoodBeverage: 'Pickup INF, Food/Beverage',
                    pickupINFHardlines: 'Pickup INF, Hardlines',
                    pickupINFHome: 'Pickup INF, Home',
                },
                ship: {
                    totalShipINF: 'Total Ship INF',
                    shipINFApparel: 'Ship INF, Apparel/Accessories',
                    shipINFBeauty: 'Ship INF, Essentials/Beauty',
                    shipINFFoodBeverage: 'Ship INF, Food/Beverage',
                    shipINFHardlines: 'Ship INF, Hardlines',
                    shipINFHome: 'Ship INF, Home',
                },
                tableHeaders: {
                    units: 'Units',
                    dollars: 'Dollars',
                    inf: 'INF %',
                },
            },
        },
        unitsCompletedLabel: (percent: number) =>
            `${percent}% of Units Completed`,
    },
    loyalty: {
        title: 'Loyalty',
        tabs: {
            overview: 'Overview',
            targetCircle: 'Target Circle',
            targetCircleCard: 'Target Circle Card',
            targetCircle360: 'Target Circle 360',
        },
        timePeriods: {
            currentWeek: 'Current Week',
            lastWeek: 'Last Week',
            monthToDay: 'Month to Date',
            yearToDay: 'Year to Date',
        },
        overview: {
            currentWeek: 'Current Week',
            lastWeek: 'Last Week',
            percentTranslationsTargetCircle: '% of Transactions Target Circle',
            percentTranslationsTargetCircleCard:
                '% of Transactions Target Circle Card',
            Sun: 'Sun',
            Mon: 'Mon',
            Tue: 'Tue',
            Wed: 'Wed',
            Thu: 'Thu',
            Fri: 'Fri',
            Sat: 'Sat',
            location: 'Location',
            targetCircle: 'Target Circle',
            targetCircleCardHeading: 'Target Circle Card',
            total: 'Total',
            targetCircleCard: 'Target Circle Card',
        },
        circleCard: {
            applications: 'Applications',
            applicationNumbers: (totalApps: string, forecastApps: string) =>
                `${totalApps} of ${forecastApps}`,
            summary: 'Summary',
            location: 'Location',
            total: 'Total',
            forecast: 'Forecast',
            '% to forecast': '% to Forecast',
        },
        targetCircle: {
            signUps: 'New Signups',
            location: 'Location',
            forecast: 'Forecast',
            'target circle signups': 'Target Circle Signups',
            'target circle 360 signups': 'Target Circle 360 Signups',
            targetCircleSignUps: 'Target Circle Signups',
            percentToForecast: '% to Forecast',
            total: 'Total',
            '% to forecast': '% to Forecast',
        },
    },
    payroll: {
        title: 'Payroll',
        planHrs: 'Plan Hrs',
        actRemSchedHrs: 'Act+Rem Sched Hrs',
        weekNo: 'Week #',
        payrollRegion: 'Region',
        tabs: {
            location: 'Location',
            workgroup: 'Work Group',
            overtime: 'Overtime',
            monthly: 'Monthly',
        },
        location: {
            title: 'Payroll by Location',
            loc: 'Location',
            payrollByLocation: 'Payroll by Location',
            payrollByWeek: 'Payroll by Week',
            projFlexHours: 'Workload Flex',
            trailerFlexHours: 'Trailer Flex Hrs',
            adjustments: 'Adjustments',
            asOf: 'As of',
            location: 'Location',
            variance: 'Variance',
            thisMonth: 'This Month',
            lastMonth: 'Last Month',
            nextMonth: 'Next Month',
            otherAdjustments: 'Other Adjustments',
            projFlexHrs: 'Proj Flex Hrs',
            trailerFlex: 'Trailer Flex',
            nextMonthUnavailable: 'Next month data is not yet available.',
        },
        workgroup: {
            title: 'Planned Hours by Work Group',
            workGroup: 'Work Group',
        },
        overtime: {
            title: 'Weekly Overtime % of Total Hours - Trend',
            actualPct: 'Actual %',
            lyAdMappedPct: 'LY (Ad-Mapped) %',
            bpTtoLyAdMappedPct: 'B/(P) to LY (Ad-Mapped)',
        },
    },
    itemSearch: {
        title: 'Item Details',
        searchLabel: 'Item Search',
        searchButtonText: 'Search',
        searchInputPlaceholder: 'Search or Scan',
        searchInputPlaceholderZebra: 'Tap Here to Search or Scan',
        scanButtonAriaLabel: 'Tap to Use Scanner',
        dpciLabel: 'DPCI:',
        dpciAriaLabel: 'DPCI',
        placementCapacityDescription: ' fit',
        onHandRow: 'Quantity on Hand',
        onWithdrawalRow: 'Quantity on the Way',
        lastAuditedRow: 'Last Audited Date',
        lastReceivedRow: 'Last Received Date',
        lastSoldRow: 'Last Sold Date',
        totalSalesCardTitle: 'Total Sales Results',
        averageSalesCardTitle: 'Average Sales Results',
        location: 'Location',
        company: 'Company',
        district: 'District',
        store: 'This Store',
        unitsSold: 'Units Sold',
        sales: 'Sales $',
        itemNotFound: 'Item Not Found',
        stopScanning: 'Stop Scanning',
        quantityCheck: (floorQty: number = 0, backQty: number = 0) =>
            `${floorQty} on floor, ${backQty} in back`,
        tabs: {
            actual: 'Actual',
            forecast: 'Forecast',
        },
    },
    safety: {
        title: 'Safety',
        lagging: {
            title: 'Lagging Safety',
            Location: 'Location',
            'Guest Incident Rate': 'Guest Incident Rate',
            'TM Inj 8wk Rate': 'TM Inj 8wk Rate',
            'TM Inj YTD Rate': 'TM Inj YTD Rate',
            Company: 'Target',
        },
        total: {
            title: 'Total Safety',
            Location: 'Location',
            'All TM Reported YTD ': 'All TM Reported YTD ',
            'All Guest Reported YTD': 'All Guest Reported YTD',
            'Hazards/Near Misses': 'Hazards/Near Misses',
            Company: 'Target',
        },
        leading: {
            title: 'Leading Safety',
            Location: 'Location',
            'Safety Meetings': 'Safety Meetings',
            Observations: 'Observations',
            'Action Plans': 'Action Plans',
            Investigations: 'Investigations',
            'Invest Action Plans': 'Invest Action Plans',
            Company: 'Target',
        },
        tabs: {
            lagging: 'Lagging',
            total: 'Total',
            leading: 'Leading',
        },
        nonStoreLabel:
            'Data updates on Wednesdays and is good through Saturday',
        store: {
            'Lagging Indicators': 'Lagging Indicators',
            'Total Incidents': 'Total Team Incidents',
            'Leading Indicators': 'Leading Indicators',
        },
    },
    sales: {
        title: 'Sales',
        noPermission:
            'It looks like you don’t have permission to view sales data for this location. ' +
            'This information is restricted to specific roles.',
        tabs: {
            overview: 'Overview',
            details: 'Details',
            location: 'Location',
        },
        timePeriods: {
            today: 'Today',
            yesterday: 'Yesterday',
            weekToDate: 'Week to Date',
            lastWeek: 'Last Week',
            monthToDate: 'Month to Date',
            lastMonth: 'Last Month',
            yearToDate: 'Year to Date',
        },
        filters: {
            compPercent: 'Comp %',
            viewInDollars: 'View in $',
            viewInPercent: 'View in %',
        },
        overview: {
            hourlySales: 'Hourly Sales',
            originated: 'Originated',
            lineBusting: 'Line Busting',
            fulfilled: 'Fulfilled',
            shipFromStore: 'Ship From Store',
            driveUp: 'Drive Up',
            orderPickup: 'Order Pickup',
            shipt: 'Shipt',
            otherSales: 'Other Sales',
            saveTheSale: 'Save the Sale',
            goal: 'Goal',
            lastYear: 'Last Year',
            compPercent: 'Comp %',
            originatedCompPercent: 'Originated Comp %',
            fulfilledCompPercent: 'Fulfilled Comp %',
            twoYearCagr: '2-Year CAGR',
            basketSize: 'Basket Size',
            transactions: 'Transactions',
            total: 'Total',
            ly: 'LY',
            bpToLy: 'B/P to LY',
            bpToLyPercent: 'B/P to LY %',
            goalPercentage: 'with a goal percentage of',
            of: 'of',
            basketSizeDollar: 'Basket Size $',
            basketSizeUnits: 'Basket Size Units',
        },
        details: {
            workarea: {
                title: 'Area of Work',
                tabs: {
                    sales: 'Sales',
                    salesMix: 'Sales Mix',
                    merch: 'Merch',
                    'orig. sales': 'Orig. Sales',
                    'ful. sales': 'Ful. Sales',
                    timePeriods: {
                        today: 'Today',
                        yesterday: 'Yesterday',
                        weekToDate: 'Week to Date',
                        lastWeek: 'Last Week',
                        monthToDay: 'Month to Date',
                        yearToDay: 'Year to Date',
                    },
                },
            },
            merch: {
                title: 'Sales by Merch',
                tabs: {
                    sales: 'Sales',
                    salesMix: 'Sales Mix',
                    merch: 'Merch',
                    'orig. sales': 'Orig. Sales',
                    'ful. sales': 'Ful. Sales',
                    timePeriods: {
                        today: 'Today',
                        yesterday: 'Yesterday',
                        weekToDate: 'Week to Date',
                        lastWeek: 'Last Week',
                        monthToDay: 'Month to Date',
                        yearToDay: 'Year to Date',
                    },
                },
            },
        },
        location: {
            title: 'Sales by Location',
            tabs: {
                region: 'Region',
                Region: 'Region',
                group: 'Group',
                district: 'District',
                store: 'Store',
                sales: 'Sales',
                goal: 'Goal',
                forecast: 'Forecast',
                'variance %': 'Variance %',
                variance: 'Variance',
                compPercent: 'Comp %',
                'comp %': 'Comp %',
                'ly ad mapped': 'LY Ad Mapped',
                '2 yr cagr %': '2-Yr CAGR %',
            },
        },
        hourly: {
            hour: 'Hour',
            today: 'Today',
            variance: 'Variance',
            lyAdMapped: 'LY Ad Mapped',
            Transaction_count: 'Hourly Transaction Count',
            'Basket Size $': 'Average Basket Size ($)',
            'Basket Size U': 'Basket Size (Units)',
            'Basket $ b/(P) % LY': 'Basket $ B/(P) % LY',
            'Basket Units b/(P) % LY': 'Basket Units B/(P) % LY',
            'Transaction Count b/(P) % LY': 'Transaction Count B/(P) % LY',
        },
    },
    shortage: {
        title: 'Shortage',
        totalShortage: 'Total Shortage',
        'last inventory date': 'Last Inventory Date',
        'next scheduled inventory date': 'Next Scheduled Inventory Date',
        thisYear: {
            title: 'This Year',
        },
        merch: {
            title: 'Shortage',
        },
        top10: {
            title: 'Top 10 Shortage',
        },
        filters: {
            viewInDollars: 'View in $',
            viewInPercent: 'View in %',
        },
        table: {
            merch: 'Merch',
            dept: 'Dept',
            class: 'Class',
            'focus areas': 'Focus Areas',
            'shortage $': 'Shortage $',
            'b/p ly $': 'B/P LY $',
            'b(p) ly $': 'B(P) LY $',
            'shortage %': 'Shortage %',
            'b/p ly %': 'B/P LY %',
            'b(p) ly %': 'B(P) LY %',
            location: 'Location',
            'gm $': 'GM $',
            'gm % ': 'GM % ',
            'perishable $': 'Perishable $',
            'perishable % ': 'Perishable % ',
            region: 'Region',
            group: 'Group',
            district: 'District',
        },
    },
    storeFacts: {
        title: 'Store Facts',
        quickFacts: 'Quick Facts',
        lastYearSales: 'Last Year Sales',
        originatedSales: 'Originated Sales',
        fulfilledSales: 'Fulfilled Sales',
        totalSales: 'Total Sales',
        hours: 'Hours',
        keyDates: 'Key Dates',
        opened: 'Opened',
        lastRemodel: 'Last Remodeled',
        notAvailable: 'No Data',
        packStation: 'Pack Station',
        leadership: 'Leadership',
        store: 'Store',
        role: 'Role',
        name: 'Name',
        since: 'Since',
        capabilities: 'Capabilities',
        to: 'To',
        field: 'Field',
        inboundNodes: 'Inbound Centers',
        outboundNodes: 'Outbound Centers',
    },
    myTargetPerformance: {
        title: 'MyTarget Performance',
        noMetricsAvailable: 'No {{metricType}} metrics available',
        tabs: {
            guest: 'Guest',
            financial: 'Financial',
            team: 'Team',
        },
        historicalDetails: 'Historical Details',
        goal: 'Goal',
        seeDetails: 'See Details',
        pctGreenStores: '% Green Stores',
        location: 'Location',
        company: 'Target',
        sections: {
            financial: 'Financial',
            guestCompliance: 'Guest Compliance',
            guestEngagement: 'Guest Engagement',
            guestImpact: 'Guest Impact',
            guestReadiness: 'Guest Readiness',
            guestSatisfaction: 'Guest Satisfaction',
            team: 'Team',
        },
        metricTypes: {
            outcomes: 'Outcomes',
            levers: 'Levers',
        },
        timePeriods: {
            priorDay: 'Yesterday',
            priorWeek: 'LW',
            last4Weeks: 'L4W',
            priorMonth: 'LM',
            priorQuarter: 'LQ',
            priorYear: 'LY',
            weekToDay: 'WTD',
            monthToDay: 'MTD',
            monthToWeek: 'MTW',
            quarterToWeek: 'QTW',
            yearToDay: 'YTD',
            yearToWeek: 'YTW',
        },
        timePeriodLabels: {
            priorDay: 'Yesterday',
            priorWeek: 'Last Week',
            last4Weeks: 'Last Four Weeks',
            priorMonth: 'Last Month',
            priorQuarter: 'Last Quarter',
            priorYear: 'Last Year',
            weekToDay: 'Week to Date',
            monthToDay: 'Month to Date',
            monthToWeek: 'Month to Week',
            quarterToWeek: 'Quarter to Week',
            yearToDay: 'Year to Date',
            yearToWeek: 'Year to Week',
        },
    },
    notes: {
        notes: 'Notes',
        sales: 'Sales',
        of: 'of',
        payroll: 'Payroll',
        hours: 'Hours',
        flexPlan: 'Flex Plan',
        weather: 'Weather',
        keyStatistics: 'Key Statistics',
        'at goal': 'At Goal',
        'below goal': 'Below Goal',
        pickOnTime: 'Pick On Time',
        sfsInf: 'SFS INF',
        opuInf: 'OPU INF',
        high: 'High',
        low: 'Low',
        comp: 'Comp',
        errorText: 'Oops, Please Enter a Valid Date',
        datePickerLabel: 'Select Date',
        permissions: {
            noAccess:
                'You don’t have access to view notes for this location. If you think this is an error, please check with your leader.',
            noNotesPermissions:
                'You don’t have the right permissions to view notes. If you think this is an error, please check with your leader.',
            userLocationNotAvailable:
                'We couldn’t confirm your location access. Notes can’t be shown.',
            accessDeniedLocation:
                'You can view notes for Store {{userStoreId}}, but not Store {{currentStoreId}}. If you think this is an error, ' +
                'please check with your leader.',
            writeAccessLimited:
                'You can only write notes for your assigned store (Store {{userStoreId}}). If you think this is an error, ' +
                'please check with your leader.',
        },
        items: {
            addButton: 'Add',
            editButton: 'Edit',
            deleteButton: 'Delete',
            todo: {
                title: 'To-Do',
                label: 'Add Next To-Do',
                key: 'to_do',
            },
            attendance: {
                title: 'Attendance',
                label: 'Add Next Attendance',
                key: 'attendance',
            },
            notes: {
                title: 'Notes',
                label: 'Add a Note',
                key: 'notes',
            },
            updateButton: 'Update',
            deleteConfirmTitle: 'Are you sure you want to delete this?',
            cancelButton: 'Cancel',
            confirmButton: 'Delete',
        },
        legacy: {
            title: 'Legacy Notes',
            subtitle: 'Read Only',
        },
    },
    operationalMetrics: {
        title: 'Operations',
        historicalDetails: 'Historical Details',
        seeChartView: 'See Chart View',
        recall: {
            tabs: {
                operations: 'Operations',
                recall: 'Recall',
                incompleteRecalls: 'Incomplete Recalls',
            },
            search: {
                label: 'Search by IR number',
                placeholder: 'Search IR number',
                noResults: 'No recalls match your search.',
                clearAriaLabel: 'Clear recall search',
            },
            headings: {
                location: 'Location',
                store: 'Store',
                district: 'District',
                group: 'Group',
                region: 'Region',
                irNumber: 'IR Number',
            },
        },
        timePeriods: {
            priorDay: 'Yesterday',
            weekToDay: 'Week to Date',
            priorWeek: 'Last Week',
            monthToDay: 'Month to Date',
            priorMonth: 'Last Month',
            yearToDay: 'Year to Date',
        },
        headers: {
            needsAttention: 'Needs Attention',
            atGoal: 'At Goal',
            belowGoal: 'Below Goal',
        },
        detailsColumns: {
            location: 'Location',
            'area of store': 'Area of Store',
            'INF units': 'INF Units',
            'total attempted units': 'Total Attempted Units',
            'INF $': 'INF $',
            'INF %': 'INF %',
            'Total Picks Attempted': 'Total Picks Attempted',
            'Total Units INF %': 'Total Units INF %',
            'Total Units INF': 'Total Units INF',
            'Total INF $': 'Total INF $',
            '% of Stores Meeting Goal': '% of Stores Meeting Goal',
            'BAI %': 'BAI %',
        },
        operationsCards: {
            'Pick On Time %': 'Pick On Time %',
            'Total Picks Attempted': 'Total Picks Attempted',
            'Total Units Picked On Time': 'Total Units Picked On Time',
            'SFS INF %': 'SFS INF %',
            'Pick Up INF %': 'Pick Up INF %',
            'Ship On-Time %': 'Ship On-Time %',
            'Total Units Due To Ship Today': 'Total Units Due To Ship Today',
            'Return to Stock': 'Return to Stock',
            'Total RTS Tasks': 'Total RTS Tasks',
            'Drive Up Wait Time': 'Drive Up Wait Time',
            'Delivery Trips': 'Delivery Trips',
            'Total Priority Fill %': 'Total Priority Fill %',
            'OSA Store Addressable Lost Sales':
                'OSA Store Addressable Lost Sales',
            'Store Addressable Lost Sales %': 'Store Addressable Lost Sales %',
            'Never Outs: OSA Store Addressable Lost Sales':
                'Never Outs: OSA Store Addressable Lost Sales',
            'Event Activations': 'Event Activations',
            'Total Events Activated': 'Total Events Activated',
            'Ticketed/Salvage Unit Accuracy %':
                'Ticketed/Salvage Unit Accuracy %',
            'Total Actual Units': 'Total Actual Units',
            'Guest Price Chal %': 'Guest Price Challenge %',
            '# Tasks': '# Tasks',
            '# of Tasks': '# of Tasks',
            'RFID Compliance %': 'RFID Compliance %',
            'Scan %': 'Scan %',
            'Backroom Audit Completion %': 'Backroom Audit Completion %',
            'Backroom Audit Tasks': 'Backroom Audit Tasks',
            'Sales Floor Audit Completion %': 'Sales Floor Audit Completion %',
            'Suspect Task': 'Suspect Task',
            'Belted Lane Utilization %': 'Belted Lane Utilization %',
            'Self Checkout Utilization %': 'Self Checkout Utilization %',
            'Check Date Completion %': 'Check Date Completion %',
            'Check Date Completion % (FOOD & BEVERAGE)':
                'Check Date Completion % (FOOD & BEVERAGE)',
            'Check Date Completion % (ESSENTIALS & BEAUTY)':
                'Check Date Completion % (ESSENTIALS & BEAUTY)',
            '# DPCI Pulled': '# DPCI Pulled',
            'Drive Up TM Interaction': 'Drive Up TM Interaction',
            'Drive Up TM Interaction LY': 'Drive Up TM Interaction LY',
            'Set On-Time %': 'Set On-Time %',
            '# of POGs Due': '# of POGs Due',
            'ESIM Completion %': 'ESIM Completion %',
            'Completed Log': 'Completed Log',
            'Wait Time at Checkout': 'Wait Time at Checkout',
            'TM Interaction at Checkout': 'TM Interaction at Checkout',
            'Order Pickup TM Interaction': 'Order Pickup TM Interaction',
            'Order Pickup TM Interaction LY': 'Order Pickup TM Interaction LY',
            'Salesfloor TM Interaction': 'Salesfloor TM Interaction',
            Cleanliness: 'Cleanliness',
            'Backroom Accuracy Indicator': 'Backroom Accuracy Indicator',
            '% of Stores Meeting Goal': '% of Stores Meeting Goal',
            'Pick Up Quality Defect %': 'Pick Up Quality Defect %',
            'Total Defect Units': 'Total Defect Units',
            'Salvage Fill Completion %': 'Salvage Fill Completion %',
            'Tasks Completed': 'Tasks Completed',
            'Price Change %': 'Price Change %',
            'Task Actuals': 'Task Actuals',
            'Price Audit %': 'Price Audit %',
            'Task Expected': 'Task Expected',
            'SFS Total Defect Rate %': 'SFS Total Defect Rate %',
        },
    },
    trailer: {
        title: 'Trailer',
        tabs: {
            summary: 'Summary',
            schedule: 'Schedule',
        },
        summary: {
            unacknowledgedDcTitle: 'Unacknowledged at DC',
            unacknowledgedStoreTitle: 'Unacknowledged at Store',
            unacknowledgedTransitTitle: 'Unacknowledged in Transit',
            unacknowledgedNoTrackingTitle:
                'Unacknowledged (No Tracking Available)',
            acknowledgedTitle: 'Acknowledged',
        },
        schedule: {
            title: 'Trailer Schedule',
            timePeriods: {
                currentWeek: 'Current Week',
                lastWeek: 'Last Week',
                nextWeek: 'Next Week',
                threeWeeksOut: 'Three Weeks Out',
                fourWeeksOut: 'Four Weeks Out',
            },
            headers: {
                unloadDateTime: 'Unload Date/Time',
                sequence: 'Sequence',
                type: 'Type',
                sweep: 'Sweep',
            },
        },
        toggles: {
            showRDC: 'Show RDC',
            showFDC: 'Show FDC',
        },
        rgd: {
            location: 'Location',
            unacknowledged: 'Unacknowledged',
            red: 'Red (> 36 Hrs)',
            recentlyAcknowledged: 'Recently Acknowledged',
            today: 'Today',
        },
        details: {
            zeroHours: '0 hrs',
            billOfLading: 'Bill of Lading',
            unknownMiles: 'Unknown Miles',
            miles: 'Miles',
            lastApplication: 'Last Application',
            table: {
                type: 'Type',
                acknowledged: 'Acknowledged',
                closed: 'Closed',
                trailerNumber: 'Trailer #',
                cartons: 'Cartons',
                leadTime: 'Lead Time',
                laborHours: 'Labor Hours',
                stockingTime: 'Stocking Time',
                secondarySortingTime: 'Secondary Sorting Time',
                customBlock: 'Custom Block',
                loadZone: 'Load Zone',
                caseCartons: 'Case Cartons',
                repackCartons: 'Repack Cartons',
                sortingTime: 'Sorting Time',
                total: 'Total',
                bulk: 'Bulk',
                description: 'Description',
                eaches: 'Eaches',
                dpci: 'DPCI',
            },
            workArea: {
                workArea: 'Work Area',
                caseCartons: 'Case Cartons',
                caseUnit: 'Case Unit',
                repackCartons: 'Repack Cartons',
                repackUnits: 'Repack Units',
                total: 'Total',
            },
        },
        trailerNotFound: 'Trailer not found',
    },
    settings: {
        title: 'Settings',
        info: 'Info',
        you: 'You',
        location: 'Location',
        version: 'Version',
        help: 'Help',
        feedback: 'Feedback',
        language: 'Language',
        languages: {
            en: 'English',
            es: 'Spanish',
            EN: 'EN',
            ES: 'ES',
        },
        landingPage: 'Landing Page',
        landingPageDescription:
            'Choose your preferred starting page for the app. This can be changed any time in Settings.',
        map: 'Map',
        preferredMap: 'Preferred Map',
        mapMessage: `Choose how you’d like to open maps. We’ll save your choice for later,
         but you can update it at any time in Settings.`,
        maps: {
            google: 'Google',
            apple: 'Apple',
        },
        creatingPreferences: 'Creating User Preferences',
        updatingPreferences: 'Updating User Preferences',
        looksLikeSomethingWentWrong:
            'Looks Like Something Went Wrong Updating User Preferences',
        loading: 'Loading',
    },
    transientError: {
        title: "We're having trouble loading your permissions",
        message:
            "We couldn't load your access data right now. Please try again in a bit.",
        retryButton: 'Try again',
    },
    unauthorized: {
        title: 'Unauthorized',
        message:
            'MPM is available on personal devices for exempt leaders (ETLs and above). ' +
            'New users must request access in myAccess; search for ' +
            '"myPerformance mobile 2 (MPM2) - Power User - Prod: APP-MPM2-Poweruser".',
        forbiddenMessage: 'You are not authorized to view this content.',
        notFoundTitle: 'Unable to open MPM',
        notFoundMessage:
            'We couldn’t load the information needed to open MPM. Please try again later.',
        noUserDetailsData: 'No user details data available.',
    },
    generalErrors: {
        loadFailedRetry: 'Data load failed, click to retry',
    },
    contact: {
        mainPhone: 'Main Phone',
        fax: 'Fax',
    },
    location: {
        region: 'Region',
        group: 'Group',
        district: 'District',
        RDC: 'RDC',
        county: 'County',
    },
    timePeriods: {
        today: 'Today',
        yesterday: 'Yesterday',
        weekToDate: 'Week to Date',
        lastWeek: 'Last Week',
        monthToDate: 'Month to Date',
        lastMonth: 'Last Month',
        yearToDate: 'Year to Date',
    },
    filters: {
        compPercent: 'Comp %',
        viewInDollars: 'View in $',
        viewInPercent: 'View in %',
        viewItem: 'View Item',
        viewSubclass: 'View Subclass',
    },
    feedback: {
        thankYou: 'Thank you',
        thankYouForSubmitting: 'Thank you for submitting feedback',
        error: 'Error',
        errorSubmitting: 'Error Submitting Feedback',
        sendAMessage: 'Send Us a Message',
        message: 'Message...',
        hereToHelp:
            'Share your feedback about MPM — we use it to keep improving!',
        submitFeedback: 'Submit Feedback',
        shareFeedback: 'Share Feedback',
        footerAriaLabel: 'Open feedback form to share feedback',
    },
    'weekly hours': 'Weekly Hours',
    'prior month': 'Prior Month',
    'Actual Hrs': 'Actual Hrs',
    'Plan Hrs': 'Plan Hrs',
    'Published Hrs': 'Published Hrs',
    'b/(p) to Plan': 'B/(P) to Plan',
    'b/(p) % to Plan': 'B/(P) % to Plan',
    'b/(p) % to Published': 'B/(P) % to Published',
    'Eastern Standard Time': 'Eastern Standard Time',
    'Central Standard Time': 'Central Standard Time',
    'Mountain Standard Time': 'Mountain Standard Time',
    'Pacific Standard Time': 'Pacific Standard Time',
    EST: 'EST',
    CST: 'CST',
    MST: 'MST',
    PST: 'PST',
    'pack station': 'Pack Station',
    'Adult Beverage Pickup': 'Adult Beverage Pickup',
    'Wine & Beer Available': 'Wine & Beer Available',
    'Beer Available': 'Beer Available',
    'Drive Up': 'Drive Up',
    'Starbucks Drive Up': 'Starbucks Drive Up',
    'Vandal Resistant Glass': 'Vandal Resistant Glass',
    'Fresh Order Pick Up': 'Fresh Order Pick Up',
    'Self Checkout': 'Self Checkout',
    'Accepts WIC': 'Accepts WIC',
    'Protects brands advocates in court safer shopping':
        'Protects Brands, Advocates in Court, Safer Shopping',
    'Shipt Delivery': 'Shipt Delivery',
    'Consumer Cellular Cell Phone Activations':
        'Consumer Cellular Cell Phone Activations',
    'Fresh Grocery': 'Fresh Grocery',
    'AT&T Cell Phone Activations': 'AT&T Cell Phone Activations',
    'Off duty police or 3rd party security':
        'Off duty police or 3rd party security',
    'Prepaid Cell Phone Activations': 'Prepaid Cell Phone Activations',
    'Store Pickup': 'Store Pickup',
    'Mobile Operations': 'Mobile Operations',
    'Drive Up Returns': 'Drive Up Returns',
    'Prior Day': 'Yesterday',
    'Week to Day': 'Week to Date',
    'Prior Week': 'Last Week',
    'Month to Day': 'Month to Date',
    'Year to Day': 'Year to Date',
    'Go back to the operations screen': 'Go Back to the Operations Screen',
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    ytd: 'YTD',
    Closed: 'Closed',
    Pfresh: 'Pfresh',
    'General Merch': 'General Merch',
    'Starbucks Cafe': 'Starbucks Cafe',
    'CVS pharmacy': 'CVS Pharmacy',
    'Snack Bar - Pizza': 'Snack Bar - Pizza',
    insights: {
        title: 'Insights',
        tabs: {
            yesterday: 'Yesterday',
            weekly: 'Weekly',
        },
        details: {
            title: 'Insight Details',
            yesterday: 'Yesterday',
            week: 'Week of',
            whatChanged: 'What Changed',
            whyItMatters: 'Why It Matters',
            whereItsHappening: "Where It's Happening",
            recommendedNextMove: 'Recommended Next Move',
            tableArea: 'Area',
            tableValue: 'Value',
            tableCompStore: 'Comp',
            tableCompDistrict: 'Comp vs District',
            tableStatus: 'Status',
            statusStrong: 'Strong',
            statusWeak: 'Weak',
        },
        sectionNoData: 'There is no data for this section.',
        locationNotEnrolled: "Insights Isn't Available for This Location",
        yesterdayAtAGlance: 'Yesterday at a Glance',
        viewInsightDetails: 'View Insight Details',
        topTrendsFromLastWeek: 'Top Trends From Last Week',
        storePerformance: {
            title: 'Yesterday Comparison vs District',
            pyramid: 'Pyramid',
            department: 'Department',
        },
        category: {
            performance: 'Performance',
            digital: 'Digital',
            district: 'District',
        },
        checkBackLater: 'Try Refreshing or Check Back Later',
        errorHeading: 'Insights Are Currently Unavailable',
        storeInsightsError: {
            heading: 'Insights Are Only Available for Your Store',
            message:
                'You’re viewing a different store. To see insights, switch back to your assigned store.',
            button: 'Switch to My Store',
        },
        summaryDetails: 'Summary Details',
        summaryForYesterday: 'Summary for Yesterday,',
        summaryForWeek: 'Summary for the Week of',
        noDataTitleYesterday: 'Yesterday’s Summary Isn’t Ready Yet',
        noDataTitleWeekly: 'This Week’s Summary Isn’t Ready Yet',
        categoryPerformance: {
            heading: 'Category Performance vs District',
            strongVsDistrict: 'Strong vs District',
            weakVsDistrict: 'Weak vs District',
        },
        storeDistrictSnapshot: {
            header: 'Store Snapshot vs District',
            metric: 'Metric',
            district: 'District',
            takeaway: 'Takeaway',
        },
        funFacts: {
            header: 'Fun Facts',
        },
        audioPlayer: {
            listenToBriefing: 'Listen to briefing',
            aiAudioRecap: 'AI Audio Recap',
            viewTranscript: 'View Transcript',
            transcript: 'AI Audio Recap Transcript',
            audioLoadError: 'Unable to load audio recording',
            audioUnavailable: 'Audio is currently unavailable',
            transcriptUnavailable: 'Transcript is currently unavailable',
            fifteenSeconds: '15s',
            fastForward: 'Fast Forward',
            rewind: 'Rewind',
        },
    },
    powerBI: {
        popupError:
            'Please enable popups in your browser to view the Power BI report.',
        title: 'Power BI',
    },
}
